import React from "react";

import i18n from "../../../constants/i18n";
import Et3PageTitle from "../../../core/et3-page-title/index";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import MyCSRPrevActionsForm from "./my-csr-prev-actions-form";
import MyCSRPrevActionsTables from "./my-csr-prev-actions-data";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import ET3PageDiv from "../../../core/et3-page-div";

const MyCSRPrevActions = withLiteObserverAndTheme(() => {
  React.useEffect(() => {
    getCoreHistoryStore().setPageName(
      "CSR_MY_PREV_ACTIONS",
      "CSR_MY_PREV_ACTIONS"
    );
  }, []);
  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("MY_CSR_PREV_ACTIONS")}
        subTitle={i18n.get("MY_CSR_PREV_ACTIONS")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <MyCSRPrevActionsForm />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <MyCSRPrevActionsTables />
    </ET3PageDiv>
  );
});
export default MyCSRPrevActions;
